import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import bgLocale from "date-fns/locale/bg";
import { Controller, FieldValues, RegisterOptions, UseFormReturn } from "react-hook-form";
import _ from "lodash";

type DatePickerExtendedProps = {
  name: string;
  label: string;
  disabled?: boolean;
  form: any & UseFormReturn<FieldValues, object>;
  minDate?: Date;
  maxDate?: Date;
  rules?: Omit<RegisterOptions, string>;
};

function DatePickerExtended({
  name,
  label,
  disabled,
  form,
  minDate,
  maxDate,
  rules,
  ...props
}: DatePickerExtendedProps) {
  const {
    control,
    formState: { errors },
  } = form;

  if (minDate === undefined) {
    minDate = new Date(1900, 1, 1, 0, 0, 0, 0);
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { value, onChange } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={bgLocale}>
          <DatePicker
            {...props}
            label={label}
            localeText={{
              fieldDayPlaceholder: () => "дд",
              fieldMonthPlaceholder: () => "мм",
              fieldYearPlaceholder: () => "гггг",
            }}
            value={value ?? null}
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
            format="dd.MM.yyyy"
            onChange={onChange}
            slotProps={{
              textField: {
                error: !!_.get(errors, `${name}`),
                helperText: !!_.get(errors, `${name}`) ? _.get(errors, `${name}`).message : undefined,
                // InputProps: {
                //   endAdornment: (
                //     <IconButton
                //       sx={{ visibility: value ? "visible" : "hidden" }}
                //       onClick={() => console.log("clear clicked")}
                //     >
                //       <ClearIcon />
                //     </IconButton>
                //   ),
                // },
              },
            }}
            // v5 approach
            // -----------------------
            // renderInput={(params: any) => (
            //   <TextField
            //     {...params}
            //     label={label}
            //     onBlur={() => {
            //       if (!open) onBlur();
            //     }}
            //     focused={open}
            //     helperText={_.get(errors, `${name}.message`)}
            //     error={!!_.get(errors, `${name}`)}
            //     inputProps={
            //       !!_.get(errors, `${name}`) ? { "error-anchor": "", ...params.inputProps } : { ...params.inputProps }
            //     }
            //     InputLabelProps={{ shrink: open ? (value ? true : false) : value ? true : false }}
            //     onClick={() => {
            //       if (params.disabled) setOpen(false);
            //       else setOpen(!open);
            //     }}
            //   />
            // )}
          />
          {/* <span>{_.get(errors, `${name}`)}</span> */}
        </LocalizationProvider>
      )}
    />
  );
}

export default DatePickerExtended;
//export default memo(DatePickerExtended, datetPickerPropsAreEqual);

// function datetPickerPropsAreEqual(prev: DatePickerExtendedProps, next: DatePickerExtendedProps) {
//   const hasError = !!next.form.formState.errors[next.name];
//   const areErrorsEqual = _.isEqualWith(prev.form.formState.errors, next.form.formState.errors);
//   const hasErrorModification = !areErrorsEqual && hasError;

//   const { form: prevForm, rules: prevRules, ...prevInputProps } = prev;
//   const { form: nextForm, rules: nextRules, ...nextInputProps } = next;
//   const arePropsEqual = _.isEqualWith(prevInputProps, nextInputProps);

//   const hasPropsModification = !arePropsEqual;

//   return !(hasErrorModification || hasPropsModification);
// }
